import React, { useState } from 'react';
import { motion } from 'framer-motion';

const List = ({ advertising, show }) => {
  const [inAnimation] = useState(show);

  return (
    <tr style={{
      position: 'absolute',
      width: '100%',
      height: 54,
      transform: 'translateY(calc(-100% - 1px)',
      overflow: 'hidden',
      opacity: inAnimation ? 1 : 0
    }}>
      <motion.td
        style={{
          position: 'absolute',
          width: '100%',
          translateY: 0,
          userSelect: 'none',
          height: 54,
          opacity: 1,
          overflow: 'hidden',
          background: '#001830'
        }}
        transition={{ translateY: { duration: 0.5, delay: 2, ease: 'linear' } }}
        animate={{
          translateY: '-200%'
        }}
      >
        <div
          colSpan="4"
          style={{
            width: '100%',
            verticalAlign: 'middle',
            textAlign: 'center',
            display: 'inline-block',
            height: '50px',
            lineHeight: '50px'
          }}
        >
          <motion.div
            style={{
              position: 'absolute',
              width: '100%',
              height: 200,
              translateY: '10%',
              background:
                'radial-gradient(circle, rgba(255,255,255,0.2) 0, rgba(0,212,255,0) 100px)'
            }}
            transition={{
              translateY: {
                duration: 1,
                delay: 0,
                ease: 'linear'
              }
            }}
            animate={{ translateY: '-75%' }}
          />
          <motion.div
            style={{
              position: 'absolute',
              verticalAlign: 'middle',
              translateY: '100%',
              width: '100%',
              height: '100%',
              opacity: 0
            }}
            transition={{
              translateY: {
                duration: 1,
                delay: 0.3,
                ease: 'linear'
              },
              opacity: {
                duration: 1,
                delay: 0.7,
                ease: 'linear'
              }
            }}
            animate={{ translateY: 0, opacity: 1 }}
          >
            <img
              src={advertising}
              style={{
                verticalAlign: 'middle',
                maxHeight: 34,
                width: 'auto'
              }}
              alt=""
            />
          </motion.div>
        </div>
      </motion.td>
    </tr>
  );
};

export { List };
